module.exports = __webpack_public_path__ + "static/media/vampiress_sword.2355477e.png";